import { TAppState } from '../../types/appState';

export const hostTypeSelector = (state: TAppState) => state.hostType;
